module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    attrs: {
      "id": "recap"
    }
  }, [_c('div', {
    staticClass: "p-4 bg-gris-clair rounded-lg shadow mb-4"
  }, [_c('ul', [(_vm.fibsdd.natures.contractuel !== null) ? _c('li', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("Intervention contractuelle : "), _c('span', {
    staticClass: "font-bold text-secondary uppercase"
  }, [_vm._v(_vm._s(_vm.fibsdd.natures.contractuel === true ? 'oui' :
    'non'))])])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.natures.description) ? _c('li', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("Descriptif demande : "), _c('span', {
    staticClass: "font-bold text-secondary",
    attrs: {
      "id": "desc-demande"
    }
  }, [_vm._v(_vm._s(_vm.fibsdd.natures.description))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "font-bold mt-2 uppercase"
  }, [_vm._v("NATURE(S) DE L'INTERVENTION")]), _vm._v(" "), (_vm.fibsdd.natures.assemblage) ? _c('li', {
    staticClass: "font-bold text-secondary"
  }, [_c('p', [_vm._v("Assemblage de l'équipement")])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.natures.miseEnService) ? _c('li', {
    staticClass: "font-bold text-secondary"
  }, [_c('p', [_vm._v("Mise en service de l'équipement")])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.natures.modification) ? _c('li', {
    staticClass: "font-bold text-secondary"
  }, [_c('p', [_vm._v("Modification de l'équipement")])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.natures.maintenance) ? _c('li', {
    staticClass: "font-bold text-secondary"
  }, [_c('p', [_vm._v("Maintenance de l'équipement")])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.natures.controlePeriodique) ? _c('li', {
    staticClass: "font-bold text-secondary"
  }, [_c('p', [_vm._v("Contrôle d'étanchéité périodique")])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.natures.controleNonPeriodique) ? _c('li', {
    staticClass: "font-bold text-secondary"
  }, [_c('p', [_vm._v("Contrôle d'étanchéité non périodique")])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.natures.demantelement) ? _c('li', {
    staticClass: "font-bold text-secondary"
  }, [_c('p', [_vm._v("Démantèlement")])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.natures.retrofit) ? _c('li', {
    staticClass: "font-bold text-secondary"
  }, [_c('p', [_vm._v("Rétrofit " + _vm._s(_vm.retrait) + " => " + _vm._s(_vm.ajout))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "font-bold text-secondary"
  }, [_c('p', [_vm._v(_vm._s(_vm.fibsdd.natures.autres))])]), _vm._v(" "), _c('li', {
    staticClass: "font-bold text-secondary"
  }, [(_vm.fibsdd.natures.observations !== '' && _vm.fibsdd.natures.observations !== null) ? _c('pre', {
    attrs: {
      "id": "observ-nature"
    }
  }, [_vm._v(_vm._s(_vm.fibsdd.natures.observations))]) : _vm._e()])])]), _vm._v(" "), (_vm.fibsdd.natures.controlePeriodique || _vm.fibsdd.natures.controleNonPeriodique) ? _c('div', {
    staticClass: "p-4 bg-gris-clair rounded-lg shadow mb-4"
  }, [_c('ul', {
    staticClass: "fuites"
  }, [(_vm.fibsdd.ctrlEtanch.no_fuites === true) ? _c('p', {
    staticClass: "font-bold text-secondary"
  }, [_vm._v("AUCUNE FUITE CONSTATÉE\n            ")]) : _c('div', [_c('p', {
    staticClass: "font-bold mt-2 uppercase"
  }, [_vm._v("FUITES(S) CONSTATÉE(S)")]), _vm._v(" "), _vm._l((_vm.fuites), function(fuite) {
    return _c('li', {
      key: fuite.id
    }, [_c('p', {
      staticClass: "font-bold text-secondary"
    }, [_vm._v("Fuite " + _vm._s(fuite.order) + " (" + _vm._s(fuite.localisation) + ") :\n                        réparation " + _vm._s((fuite.reparation) ? 'réalisée' : 'à faire'))])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.operations.length > 0) ? _c('div', {
    staticClass: "p-4 bg-gris-clair rounded-lg shadow mb-4"
  }, [_c('ul', {
    staticClass: "manips"
  }, [_c('p', {
    staticClass: "font-bold mt-2 uppercase"
  }, [_vm._v("MANIPULATION(S) DE FLUIDE")]), _vm._v(" "), _vm._l((_vm.fibsdd.operations), function(op) {
    return _c('li', {
      key: op.id
    }, [_c('p', {
      staticClass: "font-bold text-secondary"
    }, [_vm._v(_vm._s(op.type) + " : " + _vm._s(op.quantite) + "Kg - " + _vm._s((op.type.indexOf('Retrait') === -1) ? _vm.ajout : _vm.retrait))])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-4 bg-gris-clair rounded-lg shadow mb-4"
  }, [_c('ul', [_c('p', {
    staticClass: "font-bold mt-2 uppercase"
  }, [_vm._v("INFORMATIONS SUR L'INTERVENTION")]), _vm._v(" "), (_vm.fibsdd.technicien) ? _c('li', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("TECHNICIEN :\n                    "), (_vm.fibsdd.technicien.nom) ? _c('span', {
    staticClass: "font-bold text-secondary",
    attrs: {
      "id": "resume-user"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.fibsdd.technicien.last_name.toUpperCase()) + " " + _vm._s(_vm.fibsdd.technicien.first_name) + "\n                    ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.temps_deplacement) ? _c('li', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("DÉPLACEMENT :\n                    "), _c('span', {
    staticClass: "font-bold text-secondary",
    attrs: {
      "id": "resume-duree-dep"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.fibsdd.informations.temps_deplacement))])])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.kilometrage) ? _c('li', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("KILOMÉTRAGE :\n                    "), _c('span', {
    staticClass: "font-bold text-secondary",
    attrs: {
      "id": "resume-kilometrage"
    }
  }, [_vm._v(_vm._s(_vm.fibsdd.informations.kilometrage))])])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.temps_intervention) ? _c('li', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("DURÉE DE L'INTERVENTION :\n                    "), _c('span', {
    staticClass: "font-bold text-secondary",
    attrs: {
      "id": "resume-duree-inter"
    }
  }, [_vm._v(_vm._s(_vm.fibsdd.informations.temps_intervention))])])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.heure_arrivee) ? _c('li', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("HEURE D'ARRIVÉE :\n                ")]), _c('p', {
    attrs: {
      "id": "resume-heure-arrivee"
    }
  }, [_vm._v(_vm._s(_vm.fibsdd.informations.heure_arrivee))])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.heure_depart) ? _c('li', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("HEURE DE DÉPART :\n                    "), _c('span', {
    staticClass: "font-bold text-secondary",
    attrs: {
      "id": "resume-heure-depart"
    }
  }, [_vm._v(_vm._s(_vm.fibsdd.informations.heure_depart))])])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.techs) ? _c('li', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("NOMBRE DE TECHNICIENS :\n                    "), _c('span', {
    staticClass: "font-bold text-secondary",
    attrs: {
      "id": "resume-techs"
    }
  }, [_vm._v(_vm._s(_vm.fibsdd.informations.techs))])])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.namesTechniciens) ? _c('li', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("NOMS DES TECHNICIENS :\n                    "), _c('span', {
    staticClass: "font-bold text-secondary",
    attrs: {
      "id": "resume-names-techs"
    }
  }, [_vm._v(_vm._s(_vm.fibsdd.informations.namesTechniciens))])])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.preventif ||
    _vm.fibsdd.informations.correctif ||
    _vm.fibsdd.informations.fromDevis ||
    _vm.fibsdd.informations.garantie ||
    _vm.fibsdd.informations.finish ||
    _vm.fibsdd.informations.needDevis) ? _c('div', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("TYPE D'INTERVENTION :")]), _vm._v(" "), (_vm.fibsdd.informations.preventif) ? _c('li', [_c('p', {
    staticClass: "font-bold text-secondary"
  }, [_vm._v("PREVENTIF (visite d'entretien)")])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.correctif) ? _c('li', [_c('p', [_vm._v("CORRECTIF (dépannage)")])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.fromDevis) ? _c('li', [_c('p', {
    staticClass: "font-bold text-secondary"
  }, [_vm._v("INTERVENTION SELON DEVIS")])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.garantie) ? _c('li', [_c('p', {
    staticClass: "font-bold text-secondary"
  }, [_vm._v("INSTALLATION SOUS GARANTIE")])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.finish) ? _c('li', [_c('p', {
    staticClass: "font-bold text-secondary"
  }, [_vm._v("TRAVAUX TERMINÉS")])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.needDevis) ? _c('li', [_c('p', {
    staticClass: "font-bold text-secondary"
  }, [_vm._v("DEVIS À RÉALISER")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.travauxEffectues) ? _c('li', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("TRAVAUX EFFECTUÉS :\n                    "), _c('span', {
    staticClass: "font-bold text-secondary",
    attrs: {
      "id": "resume-travaux"
    }
  }, [_vm._v(_vm._s(_vm.fibsdd.informations.travauxEffectues))])])]) : _vm._e(), _vm._v(" "), (_vm.fibsdd.informations.observations) ? _c('li', [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("OBSERVATIONS :\n                    "), _c('span', {
    staticClass: "font-bold text-secondary",
    attrs: {
      "id": "resume-observ"
    }
  }, [_vm._v(_vm._s(_vm.fibsdd.informations.observations))])])]) : _vm._e()])]), _vm._v(" "), (_vm.fibsdd.pieces.length > 0) ? _c('div', {
    staticClass: "p-4 bg-gris-clair rounded-lg shadow mb-4"
  }, [_c('ul', {
    staticClass: "pieces"
  }, [_c('p', {
    staticClass: "text-md text-primary"
  }, [_vm._v("FOURNITURES")]), _vm._v(" "), _vm._l((_vm.fibsdd.pieces), function(p) {
    return _c('li', {
      key: p.id
    }, [_c('p', {
      staticClass: "font-bold text-secondary"
    }, [_vm._v(_vm._s(_vm._f("upperCase")(p.designation)) + " : " + _vm._s(p.etat) + " " + _vm._s(p.qte) + " "), (p.prix) ? _c('span', [_vm._v("x " + _vm._s(p.prix) + "€")]) : _vm._e()])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " mb-4"
  }, [_c('p', {
    staticClass: "text-sm text-gray-700 italic",
    attrs: {
      "id": "cgv"
    }
  }, [_vm._v("\n            Le client soussigné reconnait l'exactitude des travaux, fournitures, frais de déplacement, temps\n            d'intervention et s'engage à en solder le montant à \"" + _vm._s(_vm.operateur) + "\".\n            Clause de réserve de propriété en application de la loi n°80335 du 12.05.80, les marchandises livrées\n            restent la propriété du vendeur jusqu'au paiement intégral de leur prix.\n            Vous avez pris connaissance de nos C G V et les acceptez.\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-150995a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/subcomponents/Recap.vue
// module id = 1006
// module chunks = 0